// Brand assets & site content for SolarArk Australia — Solar Roof Ventilation

export const CDN = "https://static.prod-images.emergentagent.com/jobs/6f1ec3d2-a27c-434d-8780-fd66dfef5e21/images";
const ASSETS = "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts";

export const IMG = {
  ventHero: `${ASSETS}/syitwz72_Install%20with%20Branding%20-%201.jpg`,
  ventCommercial: `${CDN}/7a285fdf4d2bf643e38f18edc115c36a54c6611a057a4f5ce697121df6599228.jpeg`,
  ventCloseup: `${CDN}/e1c146e28e81480b4a874511915714d420748d96d297d7aa1c8fb3c50d60501b.jpeg`,
  // Real product photography (studio cut-outs)
  sav30: `${ASSETS}/abebjf9p_Solarark_SAV30_image%20%281%29.png`,
  sav20t: `${ASSETS}/kqc03b9a_Solarark_SAV20T_image%20%282%29.png`,
  sav10: `${ASSETS}/0zepdphp_SAV-10B_small.png`,
  sav10t: `${ASSETS}/gkbixgxf_SAV-10T_small.png`,
  sav10bc: `${ASSETS}/qorg33mg_Untitled%20design%20%2820%29.png`,
  sav10swf: `${ASSETS}/de9cokcz_SAV-10SWF.png`,
  sav20: `${ASSETS}/n8t3foxu_Solarark_SAV20_image.png`,
  sav25gb: "/sav-25gb-transparent.png",
  ventRoofInstall: `${ASSETS}/txex9p5z_Gemini_Generated_Image_a3jbf3a3jbf3a3jb.webp`,
  ventNewInstall: `${ASSETS}/hzptn7ml_20260801_111707.webp`,
  ventWarehouse: `${ASSETS}/2q57gt3q_IMG_6688.webp`,
  sav40t: `${ASSETS}/y0xugggf_SAV-40T_%20%282%29.webp`,
  sav60t: `${ASSETS}/xdunxag4_sav-60T%20%281%29%20%282%29.webp`,
  sav120t: "/sav-120t-transparent.png",
  // Solar hot water imagery
  hwHero: `${CDN}/53de59c8193f609fde3a8b9646ab895b07d29ac5519366f1386f8d18a2da85b5.jpeg`,
  hwEvacuated: `${ASSETS}/xa7qqfzw_Collector%201.webp`,
  hwPool: `${CDN}/21b14e0e8aab5eadce3bb19d54285cf79d1c7cc92b75f92b26b90436fa3a3431.jpeg`,
  hwCommercial: `${ASSETS}/epb2jtc4_IMG_9104.webp`,
};

export const CONTACT = {
  phone: "1300 670 966",
  phoneHref: "tel:1300670966",
  email: "info@solarark.com.au",
};

export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/solarark/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/company/solarark" },
  { label: "Pinterest", href: "https://au.pinterest.com/lachlan3349/" },
];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/search/?api=1&query=SolarArk%20Australia%20Pty%20Ltd%20Shailer%20Park%20QLD";

// ---------- Install gallery (real installations) ----------
export const INSTALL_GALLERY = [
  { src: `${ASSETS}/iokv832u_20260707_104722.webp`, caption: "SAV-20 · Metal Roof", cat: "Residential" },
  { src: `${ASSETS}/zm3qcwmh_20260805_131156.webp`, caption: "SAV-40T · Tiled Roof", cat: "Residential" },
  { src: `${ASSETS}/bxq0kpf7_20260407_105710.webp`, caption: "SAV-20T · Tiled Roof", cat: "Residential" },
  { src: `${ASSETS}/atb6ypj1_20260710_112921.webp`, caption: "SAV-40T · Metal Roof", cat: "Residential" },
  { src: `${ASSETS}/unzo1vrl_20260417_112841.webp`, caption: "SAV-20T · Metal Roof", cat: "Residential" },
  { src: `${ASSETS}/txex9p5z_Gemini_Generated_Image_a3jbf3a3jbf3a3jb.webp`, caption: "SAV-10B · Tiled Roof", cat: "Residential" },
  { src: `${ASSETS}/tg7asoiq_Photo5.webp`, caption: "SAV-60T · Queanbeyan East NSW", cat: "Commercial" },
  { src: `${ASSETS}/rstc9ozj_IMG_6685.webp`, caption: "SAV-120T's · Sydney warehouse", cat: "Commercial" },
  { src: `${ASSETS}/ffg6lber_SolarArk%20Sav%20120%20with%202%20panels%20Green%20Earth%20Solutions%20Nambour.webp`, caption: "SAV-120T · Nambour QLD", cat: "Commercial" },
  { src: `${ASSETS}/awuie6po_Solarark%20trim%20roof%20Tewantin%20Green%20Earth%20Solutions%20%285%29.webp`, caption: "SAV-60T · Tewantin QLD", cat: "Commercial" },
  { src: `${ASSETS}/kbrpts7g_amazing%20skylights1.JPG`, caption: "SAV-120T's · Warehouse install", cat: "Commercial" },
];

export const NAV_PAGES = [
  { label: "Solar Hot Water", to: "/solar-hot-water" },
  { label: "Solar Roof Ventilation", to: "/solar-roof-ventilation" },
  { label: "NCC Compliance", to: "/ncc-compliance" },
  { label: "Blog", to: "/blog" },
  { label: "About", to: "/about" },
  { label: "Downloads", to: "/downloads" },
];

export const MARQUEE = [
  "Up to 30°C Cooler", "Zero Running Costs", "Whisper Quiet", "Solar Powered",
  "Vermin Proof", "Digital Thermostat", "Since 2009", "Up to 11,220 m³/hr",
];

// Individual model brochures (PDF)
const MODEL_BROCHURES = {
  "sav-10b": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/2po64gck_SAV-10B%20Brochure.pdf",
  "sav-10t": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/pw91n40n_SAV-10T%20Brochure.pdf",
  "sav-10bc": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/u26v48lz_SAV-10BC%20Brochure.pdf",
  "sav-10swf": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/bdfvzpv8_SAV-10SWF%20Brochure.pdf",
  "sav-20": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/0hkqwk6e_SAV-20%20Brochure.pdf",
  "sav-20t": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/x1zjh92x_SAV-20T%20Brochure.pdf",
  "sav-30": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/9t0fr9je_SAV-30%20Brochure.pdf",
  "sav-40t": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/4wci3xu5_SAV-40T%20Brochure.pdf",
  "sav-60t": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/nbkghv2m_SAV-60T%20Brochure.pdf",
  "sav-120t": "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/yi17b3en_SAV-120T%20Brochure.pdf",
};

// Hero products for the showcase grid (real photography)
export const PRODUCTS = [
  {
    id: "sav-25gb",
    name: "SAV-2.5GB",
    sub: "Gable / Wall Mount",
    tagline: "The ultra-compact gable and wall-mounted vent — ideal for tight spaces, sub-floors and garages where roof mounting isn't an option.",
    flow: "450",
    power: "2.5W",
    image: IMG.sav25gb,
    span: "lg:col-span-1",
  },
  {
    id: "sav-10b",
    name: "SAV-10B",
    sub: "Compact Residential",
    tagline: "The low-profile entry point — flush-mounted solar panel with 1,112 m³/hr of silent extraction for north-facing roofs.",
    flow: "1,112",
    power: "10W",
    image: IMG.sav10,
    brochure: MODEL_BROCHURES["sav-10b"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-10t",
    name: "SAV-10T",
    sub: "Compact Tilt-Panel",
    tagline: "All the compact performance of the SAV-10B with a directional tilt panel — install on any roof orientation.",
    flow: "1,112",
    power: "10W",
    image: IMG.sav10t,
    brochure: MODEL_BROCHURES["sav-10t"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-20",
    name: "SAV-20",
    sub: "Residential Workhorse",
    tagline: "Serious extraction with a flush-mounted panel — the go-to unit for north-facing residential roofs.",
    flow: "2,718",
    power: "20W",
    image: IMG.sav20,
    brochure: MODEL_BROCHURES["sav-20"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-20t",
    name: "SAV-20T",
    sub: "Tilt-Panel Residential",
    tagline: "Astonishing airflow with a directional tilt panel for any roof orientation.",
    flow: "2,718",
    power: "20W",
    image: IMG.sav20t,
    brochure: MODEL_BROCHURES["sav-20t"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-30",
    name: "SAV-30",
    sub: "Residential Flagship",
    tagline: "The big residential performer with slim designer styling and huge extraction for larger homes.",
    flow: "3,150",
    power: "30W",
    image: IMG.sav30,
    brochure: MODEL_BROCHURES["sav-30"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-40t",
    name: "SAV-40T",
    sub: "Commercial Entry",
    tagline: "Massive flow and a directional tilt panel — the start of our commercial range.",
    flow: "3,660",
    power: "40W",
    image: IMG.sav40t,
    brochure: MODEL_BROCHURES["sav-40t"],
    span: "lg:col-span-1",
  },
  {
    id: "sav-60t",
    name: "SAV-60T",
    sub: "Commercial High-Flow",
    tagline: "One SAV-60T moves the same air as up to 52 traditional whirlybirds — at zero running cost.",
    flow: "5,250",
    power: "60W",
    image: IMG.sav60t,
    brochure: MODEL_BROCHURES["sav-60t"],
    span: "lg:col-span-2",
  },
  {
    id: "sav-120t",
    name: "SAV-120T",
    sub: "Commercial Flagship",
    tagline: "Our most powerful ventilator — 11,220 m³/hr for spaces up to 1,122 m³, digitally thermostat controlled with dual-panel solar power.",
    flow: "11,220",
    power: "240W",
    image: IMG.sav120t,
    brochure: MODEL_BROCHURES["sav-120t"],
    span: "lg:col-span-3",
  },
];

// Full technical spec table (from 2025 brochure)
export const SPECS = [
  { model: "SAV-2.5GB", flow: "450", power: "2.5W", placement: "Gable/Wall", weight: "3kg", pv: "5yr", motor: "3yr", range: "Compact" },
  { model: "SAV-10B", flow: "1,112", power: "10W", placement: "North", weight: "6kg", pv: "5yr", motor: "5yr", range: "Residential" },
  { model: "SAV-10T", flow: "1,112", power: "10W", placement: "All directions", weight: "7kg", pv: "5yr", motor: "5yr", range: "Residential" },
  { model: "SAV-20", flow: "2,718", power: "20W", placement: "North", weight: "12kg", pv: "10yr", motor: "5yr", range: "Residential" },
  { model: "SAV-20T", flow: "2,718", power: "20W", placement: "All directions", weight: "13kg", pv: "10yr", motor: "5yr", range: "Residential" },
  { model: "SAV-30", flow: "3,150", power: "30W", placement: "North", weight: "14kg", pv: "10yr", motor: "5yr", range: "Residential" },
  { model: "SAV-40T", flow: "3,660", power: "40W", placement: "All directions", weight: "17kg", pv: "10yr", motor: "5yr", range: "Commercial" },
  { model: "SAV-60T", flow: "5,250", power: "60W", placement: "All directions", weight: "20kg", pv: "10yr", motor: "5yr", range: "Commercial" },
  { model: "SAV-120T", flow: "11,220", power: "240W", placement: "All directions", weight: "45kg", pv: "10yr", motor: "5yr", range: "Large Commercial" },
];

// The SolarArk Advantage (numbered chapters)
export const CHAPTERS = [
  {
    n: "01",
    title: "Cooler in Summer",
    body: "SolarArk solar roof ventilators reduce roof-cavity temperatures by up to 30°C and living-room temperatures by up to 6°C — extracting the same airflow as up to 27 traditional whirlybirds.",
  },
  {
    n: "02",
    title: "Zero Running Costs",
    body: "Being totally solar powered, our entire range operates at $0 for the whole life of the product. No wiring, no switches, no bills — just free, silent airflow whenever the sun is out.",
  },
  {
    n: "03",
    title: "Healthier Air",
    body: "Continuous extraction reduces condensation and the likelihood of mould spores building up in your roof space — protecting the health and air quality inside your home.",
  },
  {
    n: "04",
    title: "Smart & Silent",
    body: "A brushless DC motor and polycarbonate blades run whisper-quiet, while an adjustable digital thermostat gives precise on/off control and retains roof warmth through the colder months.",
  },
];

export const STATS = [
  { value: 30, suffix: "°C", label: "Cooler roof cavity" },
  { value: 6, suffix: "°C", label: "Cooler living rooms" },
  { value: 52, suffix: "×", label: "Whirlybirds replaced by one SAV-60T" },
  { value: 11220, suffix: "", label: "Max airflow m³/hr (SAV-120T)" },
];

// ---------- Whirlybird vs SolarArk comparison ----------
export const WHIRLYBIRD = {
  overline: "The Whirlybird Alternative",
  title: "A superior alternative to whirlybirds.",
  subtitle: "Searching for whirlybirds? Here's why thousands of Australians upgrade to solar. A traditional whirlybird is a passive wind vent — it only spins when the wind blows and stops the moment the air goes still. SolarArk uses free energy from the sun to actively extract heat all day long, giving you a roof-ventilation solution that actually works.",
  rows: [
    { feature: "Power source", whirlybird: "Wind only — dead calm days do nothing", solarark: "Solar powered — works whenever the sun is out" },
    { feature: "Airflow", whirlybird: "≈ 100 m³/hour on a windy day", solarark: "Up to 11,220 m³/hour, continuously" },
    { feature: "Units to cool a warehouse", whirlybird: "Up to 52 spinning vents", solarark: "One SAV-60T does the same job" },
    { feature: "Extraction", whirlybird: "Passive — relies on the weather", solarark: "Active, motor-driven, sun-up to sun-down" },
    { feature: "Noise", whirlybird: "Can squeak, rattle and seize over time", solarark: "Whisper-quiet brushless DC motor" },
    { feature: "Vermin & weather", whirlybird: "Open throat — entry point for pests", solarark: "Fully vermin proof, sealed design" },
    { feature: "Control", whirlybird: "None", solarark: "Adjustable digital thermostat" },
    { feature: "Running cost", whirlybird: "$0 — but only when it's windy", solarark: "$0 — with full performance every sunny day" },
  ],
};

export const CASES = [
  {
    title: "Suburban Home — Western Sydney, NSW",
    category: "Residential",
    result: "Two SAV-20 vents dropped roof-cavity temps by 28°C and cut summer AC runtime dramatically.",
    image: IMG.ventCloseup,
  },
  {
    title: "Distribution Warehouse — Truganina, VIC",
    category: "Commercial",
    result: "A bank of SAV-60T ventilators keeps a 4,000 m² steel roof cool at zero running cost.",
    image: IMG.ventCommercial,
  },
  {
    title: "Hillside Acreage — Adelaide Hills, SA",
    category: "Residential",
    result: "Tilt-panel SAV-20T units solved a non-north-facing roof and eliminated attic condensation.",
    image: IMG.ventHero,
  },
];

export const FAQS = [
  {
    q: "How much cooler will my roof actually get?",
    a: "SolarArk ventilators can reduce roof-cavity temperatures by up to 30°C and living-room temperatures by up to 6°C, which significantly improves the efficiency of ducted air conditioning and saves you money.",
  },
  {
    q: "Are SolarArk ventilators better than whirlybirds?",
    a: "Yes — and it isn't close. A traditional whirlybird is a passive wind vent that only spins when the wind blows, moving roughly 100 m³/hour on a windy day and nothing at all when the air is still. A SolarArk solar roof ventilator uses a motor driven by free energy from the sun to actively extract thousands of cubic metres of hot air every hour, continuously, from sun-up to sun-down. One SAV-60T moves the same air as up to 52 whirlybirds — so a SolarArk unit delivers a solution that actually works instead of one that depends on the weather.",
  },
  {
    q: "Can I replace my existing whirlybirds with a SolarArk ventilator?",
    a: "Absolutely. Most customers upgrading from whirlybirds find that a single SolarArk solar ventilator replaces several spinning wind vents while delivering far more airflow, no squeaks or rattles, and a fully vermin-proof design. Tell us how many whirlybirds you have and the size of your roof, and our team will recommend the right SolarArk model to replace them.",
  },
  {
    q: "Do they cost anything to run?",
    a: "No. The entire SolarArk range is totally solar powered, so there is a $0 operating cost over the whole life of the product — no wiring to switchboards and no electricity bills.",
  },
  {
    q: "My roof doesn't face north. Will they still work?",
    a: "Yes. Our tilt-panel models (the 'T' range — SAV-10T, SAV-20T, SAV-40T, SAV-60T) have a directional solar panel that can be angled toward the sun for non-north-facing installations, delivering full performance in all directions.",
  },
  {
    q: "Which model do I need for my roof?",
    a: "It depends on your roof size, pitch and orientation — use our interactive airflow calculator below to get an instant recommendation. As a rule, a 100 m² roof suits a SAV-10B while larger or steeper roofs step up to the SAV-20, SAV-30 or multiple units. Our team confirms the right model before you buy.",
  },
  {
    q: "Are they noisy, and are they vermin proof?",
    a: "They're whisper-quiet thanks to a brushless DC motor and polycarbonate blades. All residential and commercial models (SAV-10B and above) are vermin proof. Note: installation isn't recommended on roofs steeper than 28° due to water-ingress risk.",
  },
  {
    q: "Who installs it — can I do it myself?",
    a: "Both options work. Every SolarArk ventilator is designed for straightforward DIY installation with basic tools, and full instructions are included. Prefer a pro? We don't install directly, but we'll happily connect you with a trusted installer from our national network.",
  },
  {
    q: "What warranty is included?",
    a: "Depending on the model, solar PV panels carry a 5 or 10-year warranty and motors carry a 3 or 5-year warranty. Larger models (SAV-20 and up) include the 10-year PV / 5-year motor cover.",
  },
];

export const PRODUCT_OPTIONS = [
  "SAV-2.5GB (Compact)",
  "SAV-10B / SAV-10T (Residential)",
  "SAV-10BC / SAV-10SWF (Shipping Container)",
  "SAV-20 / SAV-20T (Residential)",
  "SAV-30 (Residential)",
  "SAV-40T / SAV-60T (Commercial)",
  "SAV-120T (Large Commercial)",
  "Not sure — need advice",
];

export const PROPERTY_OPTIONS = ["Residential", "Commercial", "Industrial"];

// ---------- Home page category chooser ----------
export const CATEGORIES = [
  {
    id: "hot-water",
    kicker: "01 — Solar Hot Water",
    title: "Solar Hot Water",
    blurb: "Evacuated tube systems, pool heating and commercial solar thermal — up to 90% of your water heating drawn straight from the sun.",
    image: IMG.hwEvacuated,
    to: "/solar-hot-water",
  },
  {
    id: "ventilation",
    kicker: "02 — Solar Roof Ventilation",
    title: "Solar Roof Ventilation",
    blurb: "Whisper-quiet, solar-powered roof ventilators that make your roof up to 30°C cooler at zero running cost.",
    image: IMG.ventWarehouse,
    to: "/solar-roof-ventilation",
  },
];

export const HOME_STATS = [
  { value: 30000, suffix: "+", label: "Homes & businesses served" },
  { value: 2009, suffix: "", label: "Trusted since", raw: true },
  { value: 15, suffix: "yr", label: "System warranties" },
  { value: 0, suffix: "$", label: "Solar running costs", raw: true },
];

// ---------- Solar Hot Water content ----------
export const HW_PRODUCTS = [
  {
    id: "evacuated-tube",
    name: "Evacuated Tube Systems",
    sub: "Residential",
    tagline: "High-efficiency evacuated tube collectors deliver up to 90% of your hot water from the sun — even on cold, overcast days.",
    flow: "UP TO 90% SOLAR",
    power: "300L TANK",
    image: IMG.hwEvacuated,
    span: "lg:col-span-2",
  },
  {
    id: "pool-heating",
    name: "Solar Pool Heating",
    sub: "Residential",
    tagline: "Extend your swim season by up to five months with UV-stabilised solar pool heating.",
    flow: "EPDM COLLECTORS",
    power: "AUTO CONTROL",
    image: IMG.hwPool,
    span: "lg:col-span-1",
  },
  {
    id: "commercial-thermal",
    name: "Commercial Solar Thermal",
    sub: "Commercial",
    tagline: "Custom-engineered thermal plants for hotels, gyms, laundries and industry — rebate eligible.",
    flow: "CUSTOM kW",
    power: "ENGINEERED",
    image: IMG.hwCommercial,
    span: "lg:col-span-2",
  },
];

export const HW_CHAPTERS = [
  { n: "01", title: "Harness", body: "Australia receives the highest average solar radiation of any continent. Our evacuated tubes convert that abundance into hot water every day of the year." },
  { n: "02", title: "Reduce", body: "Hot water typically accounts for around 38% of an Australian household's energy bill. Our evacuated tube systems slash that load by up to 90%, saving you money year after year." },
  { n: "03", title: "Endure", body: "Marine-grade stainless, freeze-tolerant tubes and cyclone-rated mounting — engineered for every Australian climate." },
  { n: "04", title: "Sustain", body: "A single system prevents tonnes of CO₂ across its lifetime, backed by generous federal STC rebates." },
];

export const HW_STATS = [
  { value: 90, suffix: "%", label: "Water heating from the sun" },
  { value: 15, suffix: "yr", label: "Collector & tank warranty" },
  { value: 30000, suffix: "+", label: "Australian installs" },
  { value: 2009, suffix: "", label: "Trusted since", raw: true },
];

export const HW_FAQS = [
  { q: "How much can solar hot water save me?", a: "Households typically reduce water-heating energy use by up to 90%. Actual savings depend on climate, usage and your current system — request a quote and we'll model your specific return on investment." },
  { q: "Am I eligible for government rebates?", a: "Most SolarArk solar hot water systems qualify for Small-scale Technology Certificates (STCs) under the federal Renewable Energy Target, plus various state-based incentives. We calculate your exact rebate before you commit." },
  { q: "Will it work in cold or cloudy weather?", a: "Yes. Evacuated tube collectors are highly efficient in low ambient temperatures and diffuse light, and every system includes a boosted backup so you never run out of hot water." },
  { q: "What warranty is included?", a: "Our evacuated tube collectors are backed by a 15-year warranty. Solar hot water must be installed by a licensed plumber — we can connect you with one through our national installer network." },
  { q: "How long does installation take?", a: "A typical residential installation is completed by a licensed plumber in a single day. For commercial systems, our in-house engineers design the system and installation is scheduled around your operations." },
];

export const HW_PRODUCT_OPTIONS = [
  "Evacuated Tube Solar Hot Water",
  "Solar Pool Heating",
  "Commercial Solar Thermal",
  "Not sure — need advice",
];

// ---------- Solar Hot Water — evacuated tube technical data (2025 brochure) ----------
export const HW_COMPARE = [
  { label: "Heat retention", tube: "Vacuum insulates each tube like a thermos — virtually no heat loss", flat: "Significant heat loss through the front glass panel" },
  { label: "Reflection", tube: "Cylindrical tubes catch the sun's rays all day and reflect less", flat: "Flat surface reflects more of the sun's energy" },
  { label: "Max collector temp", tube: "Up to 280°C", flat: "Up to 180°C" },
  { label: "Cold / frost climates", tube: "Excellent — suited to frost, snow and rapid temperature change", flat: "Reduced performance in cold conditions" },
];

export const HW_SPECS = [
  { tubes: "20 Tube", absorber: "1.60 m²", aperture: "1.88 m²", gross: "2.96 m²", fluid: "1,546 mL", weight: "78 kg", dims: "1560 × 2000 mm" },
  { tubes: "30 Tube", absorber: "2.40 m²", aperture: "2.82 m²", gross: "4.35 m²", fluid: "2,338 mL", weight: "115 kg", dims: "2310 × 2000 mm" },
];

export const HW_SIZING = [
  { tank: "270 L", collector: "20 Tube Manifold", suits: "Small–medium household" },
  { tank: "340 L", collector: "20 Tube Manifold", suits: "Medium household" },
  { tank: "340 L", collector: "30 Tube Manifold", suits: "Medium–large household" },
  { tank: "450 L", collector: "30 Tube Manifold", suits: "Large household" },
];

export const HW_TANKS = [
  { type: "Vitreous Enamel", sizes: "270 L · 340 L · 450 L" },
];

export const HW_CERTS = ["WaterMark Certified", "JAS-ANZ Accredited", "Australian Owned & Designed", "15-Year Collector Warranty"];

// ---------- Customer reviews (real Google reviews) ----------
export const REVIEWS = [
  {
    name: "Greg Chapman",
    source: "Google Review",
    stars: 5,
    text: "After receiving very professional advice and service from Christian, I had a SAV-20 installed. I looked at other similar products but I found SolarArk to be a far superior product. The overall effect for comfort is considerably noticeable, not to mention cost-effective. Now hot air and condensation dissipate much quicker and more efficiently. Highly recommend SolarArk.",
    featured: true,
  },
  {
    name: "Shane Hage",
    source: "Google Review",
    stars: 5,
    text: "Does exactly what they say they do. Silent and good looking!",
  },
  {
    name: "Godfrey Wenness",
    source: "Google Review",
    stars: 5,
    text: "Excellent service, great product knowledge and prompt delivery — overnight from Brisbane to regional NSW!",
  },
  {
    name: "Craig Olsen",
    source: "Google Review",
    stars: 5,
    text: "Very helpful! We were hunting for parts for our solar tube system and no-one wanted to help, or the prices quoted were ridiculous. I found SolarArk and found what we needed — reasonable prices and very friendly service. Thank you!",
  },
  {
    name: "Stephen Busch",
    source: "Google Review",
    stars: 5,
    text: "Great roof vents and support, highly recommend. Ike, thanks again for all the phone support!",
  },
];

// ---------- About ----------
export const ABOUT_INTRO = "SolarArk believes that we can use technology to improve our environment and our economy. Our passion has seen us become a market leader by being \u201CBetter by Design\u201D, with a team of engineers and technicians with exceptional knowledge and expertise.";

export const ABOUT_PARAS = [
  {
    n: "01",
    title: "Better by Design",
    body: "We focus on helping our customers understand and leverage the advantages of solar energy — combining exceptional engineering knowledge with a genuine passion for a cleaner, cheaper way to power Australian buildings.",
  },
  {
    n: "02",
    title: "Solar Hot Water",
    body: "SolarArk remains committed to the long-term design and manufacture of our Evacuated Tube Solar Hot Water systems, which continue to deliver unrivalled efficiency and performance across every Australian climate.",
  },
  {
    n: "03",
    title: "Roof Ventilation",
    body: "Our roof ventilators keep you cooler in summer and improve the energy efficiency of your cooling system. Standard thermostatic shut-off systems help keep the warmth in during cooler weather.",
  },
  {
    n: "04",
    title: "In-house Engineering",
    body: "We have in-house engineers that can design any commercial solar hot water, solar roof ventilation or pool heating system — Australia's highest performer, with uncompromised quality and leading warranties.",
  },
];

export const OFFICES = [
  { city: "Canberra, ACT", address: "7A / 59 Vicars St, Mitchell ACT 2911" },
  { city: "Brisbane, QLD", address: "Unit 2, 2–12 Knobel Court, Shailer Park QLD 4128" },
];

// ---------- Downloads ----------
const BROCHURE = "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/qj2zhjur_SolarArk%20Solar%20Roof%20Ventilation%20Brochure%202026.pdf.pdf";
const EVAC_BROCHURE = "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/kj101hqh_SolarArk%20Australia%20Evacuated%20Tube%20Solar%20Hot%20Water%20Brochure.pdf";
export const NCC_GUIDE = "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/9bfue67t_NCC%20Ventilation%20Guide.pdf";
const QA_GUIDE = "https://www.solarark.com.au/wp-content/uploads/2021/10/QA-GUIDE-.pdf";
const WARRANTIES = "https://www.solarark.com.au/warranties/";

export const DOWNLOADS = [
  {
    group: "Product Brochures",
    items: [
      { title: "Solar Roof Ventilation Brochure 2026", desc: "Complete SAV range, features, applications and airflow data.", type: "PDF", size: "4.1 MB", href: BROCHURE },
      { title: "Evacuated Tube Solar Hot Water Brochure", desc: "Evacuated tube technology, system sizing, tank options and specifications.", type: "PDF", size: "27 MB", href: EVAC_BROCHURE },
    ],
  },
  {
    group: "Compliance",
    items: [
      { title: "NCC 2022 — Clause 10.8.3 Ventilation Guide", desc: "How SolarArk ventilators meet & exceed roof-space ventilation and condensation management requirements.", type: "PDF", size: "2.4 MB", href: NCC_GUIDE },
    ],
  },
  {
    group: "Model Brochures — SAV Range",
    items: [
      { title: "SAV-10B Brochure", desc: "Compact residential solar roof ventilator — flush-mounted panel, north-facing roofs.", type: "PDF", size: "2.3 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/2po64gck_SAV-10B%20Brochure.pdf" },
      { title: "SAV-10T Brochure", desc: "Compact residential ventilator with tilt panel — any roof orientation.", type: "PDF", size: "1.7 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/pw91n40n_SAV-10T%20Brochure.pdf" },
      { title: "SAV-10BC Brochure", desc: "Container solar roof ventilator — for 20ft and 40ft shipping containers.", type: "PDF", size: "1.6 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/u26v48lz_SAV-10BC%20Brochure.pdf" },
      { title: "SAV-10SWF Brochure", desc: "Container solar wall-mounted ventilator — for 20ft shipping containers.", type: "PDF", size: "1.6 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/bdfvzpv8_SAV-10SWF%20Brochure.pdf" },
      { title: "SAV-20 Brochure", desc: "Residential solar roof ventilator — north-facing placement, 2,718 m³/hr airflow.", type: "PDF", size: "2.3 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/0hkqwk6e_SAV-20%20Brochure.pdf" },
      { title: "SAV-20T Brochure", desc: "Residential solar roof ventilator — all-direction placement with tilted panel.", type: "PDF", size: "2.3 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/x1zjh92x_SAV-20T%20Brochure.pdf" },
      { title: "SAV-30 Brochure", desc: "High-capacity solar roof ventilator for larger residential roofs.", type: "PDF", size: "1.5 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/9t0fr9je_SAV-30%20Brochure.pdf" },
      { title: "SAV-40T Brochure", desc: "Large residential / light commercial ventilator — all-direction placement.", type: "PDF", size: "1.7 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/4wci3xu5_SAV-40T%20Brochure.pdf" },
      { title: "SAV-60T Brochure", desc: "Commercial-grade solar roof ventilator — moves the air of up to 52 whirlybirds.", type: "PDF", size: "1.9 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/nbkghv2m_SAV-60T%20Brochure.pdf" },
      { title: "SAV-120T Brochure", desc: "Flagship large-commercial ventilator — 11,220 m³/hr for spaces up to 1,122 m³.", type: "PDF", size: "2.9 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/yi17b3en_SAV-120T%20Brochure.pdf" },
    ],
  },
  {
    group: "Specifications",
    items: [
      { title: "SAV Range — Full Specifications", desc: "Airflow, power, placement, weight and warranty for all 9 models, including roof sizing recommendations.", type: "PDF", size: "4.1 MB", href: BROCHURE },
    ],
  },
  {
    group: "Guides & FAQs",
    items: [
      { title: "SolarArk Q&A Guide", desc: "Answers to the most common solar hot water and ventilation questions.", type: "PDF", size: "1.2 MB", href: QA_GUIDE },
    ],
  },
  {
    group: "Warranties",
    items: [
      { title: "Solar Roof Ventilation Warranty Guidelines 2026", desc: "Official warranty guidelines for the SolarArk solar roof ventilation range.", type: "PDF", size: "0.2 MB", href: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/eve8vit3_SolarArk-Australia-Warranty-Guidelines-2026.pdf" },
    ],
  },
];

// ---------- NCC 10.8.3 compliance ----------
export const NCC_REQUIREMENTS = [
  { pitch: "< 10°", vent: "25,000 mm²/m at each of two opposing ends" },
  { pitch: "≥ 10° and < 15°", vent: "25,000 mm²/m at the eaves + 5,000 mm²/m at high level" },
  { pitch: "≥ 15° and < 75°", vent: "7,000 mm²/m at eaves + 5,000 mm²/m at high level (+18,000 mm²/m at eaves for cathedral ceilings)" },
];

export const NCC_FOA = [
  { model: "SAV-10B / SAV-10T", area: "0.055 m²", mm: "55,000 mm²" },
  { model: "SAV-20 / SAV-20T", area: "0.20 m²", mm: "200,000 mm²" },
  { model: "SAV-30 / SAV-40T", area: "0.10 m²", mm: "100,000 mm²" },
  { model: "SAV-60T", area: "0.20 m²", mm: "200,000 mm²" },
  { model: "SAV-120T", area: "0.31 m²", mm: "310,000 mm²" },
];

export const NCC_STEPS = [
  {
    n: "01",
    title: "High-level ventilation",
    req: "20 m horizontal length × 5,000 mm²/m = 100,000 mm² required",
    sol: "One SAV-20/20T delivers 200,000 mm² free open area.",
  },
  {
    n: "02",
    title: "Eave (low-level) ventilation",
    req: "20 m × 7,000 mm²/m = 140,000 mm² required",
    sol: "7 eave vents @ 20,000 mm² FOA each = 140,000 mm².",
  },
  {
    n: "03",
    title: "Effective flow rate",
    req: "200 m² roof × ½ × 2.4 m height × 10 ACH = 2,400 m³/hr required",
    sol: "SAV-20/20T operates at 2,712 m³/hr — exceeding the target.",
  },
];

export const NCC_SIZING = [
  { model: "SAV-10B / SAV-10T", rule: "1 unit per 10.94 m of horizontal roof length" },
  { model: "SAV-20 / SAV-20T", rule: "1 unit per 39 m of horizontal roof length" },
];

// ---------- Blog ----------
export const BLOG = [
  {
    slug: "shed-ventilation-solar-roof-ventilation",
    title: "Shed Ventilation: Why Solar Roof Ventilation Makes a Difference",
    excerpt: "Sheds, workshops and garages trap serious heat in summer. Here's how a solar-powered roof ventilator — often called a solar whirlybird — clears hot, stale air and improves airflow at zero running cost.",
    category: "Ventilation",
    date: "25 Sep 2026",
    read: "5 min read",
    author: "SolarArk Team",
    iso: "2026-09-25",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/4oarlccm_IMG_0582.webp",
    body: [
      { p: "Sheds, workshops and garages can become extremely hot and stuffy, particularly through the warmer months. With large metal roofs absorbing heat throughout the day, temperatures inside can quickly climb well above the outdoor temperature." },
      { p: "Solar roof ventilation is a simple way to help remove that built-up heat and improve airflow throughout your shed." },

      { h: "How does shed ventilation work?" },
      { p: "A solar roof ventilator works by drawing hot, stale air from inside the shed and exhausting it through the roof. As hot air is removed, fresh air is naturally drawn in through available openings such as eaves, doors, vents or wall gaps." },
      { p: "Unlike a passive whirlybird, a powered solar ventilator uses a solar panel to actively drive a high-flow fan. This means it can move significantly more air and provide more effective ventilation across larger shed spaces." },

      { h: "What are the benefits?" },
      { p: "Installing solar ventilation in a shed can help:" },
      { ul: [
        "Reduce heat build-up inside the shed",
        "Improve airflow and reduce stagnant air",
        "Make workshops and garages more comfortable to work in",
        "Help reduce moisture and condensation",
        "Protect stored equipment and belongings from prolonged heat and humidity",
        "Reduce the amount of heat transferred into adjoining areas",
        "Provide ventilation with no ongoing electricity costs during normal solar operation",
      ] },
      { p: "For larger sheds and workshops, multiple ventilators can be installed to achieve the required airflow and ventilation rate." },

      { h: "Why do people call them a \u201Csolar whirlybird\u201D?" },
      { p: "The term \u201Csolar whirlybird\u201D has become a common way of describing solar-powered roof ventilators because they perform a similar job to the traditional whirlybird \u2014 they remove hot air from the roof space. The key difference is how they operate." },
      { p: "A traditional whirlybird relies on wind and natural convection to turn the turbine and move air. A solar roof ventilator uses a powered fan driven by a solar panel, allowing it to actively extract much larger volumes of air regardless of whether there is much wind." },
      { p: "So while \u201Csolar whirlybird\u201D is a popular name, products such as the SolarArk SAV range are more accurately described as solar-powered roof ventilators." },

      { h: "The right ventilation for your shed" },
      { p: "The amount of ventilation required depends on the size and height of the shed, how it is used and the amount of heat being generated inside. For a workshop, machinery shed, garage or large storage area, selecting the correct airflow capacity is important to ensure the system can effectively exchange the air within the space." },
      { p: "If your shed becomes unbearably hot during summer, solar roof ventilation can be a simple and effective way to get the air moving and help create a more comfortable environment." },
    ],
  },
  {
    slug: "solar-roof-ventilation-commercial-workshops-warehouses",
    title: "Why Solar Roof Ventilation Matters for Commercial Workshops and Warehouses",
    excerpt: "Large workshops and warehouses trap thousands of cubic metres of hot air. Here's how to size high-capacity solar ventilation by air changes per hour — no roof cavity required.",
    category: "Commercial",
    date: "12 Jun 2026",
    read: "8 min read",
    author: "SolarArk Team",
    iso: "2026-06-12",
    image: "https://customer-assets-rejwkqb3.emergentagent.net/job_eco-thermal-2/artifacts/tsqr562o_COM%20BLOG.webp",
    body: [
      { p: "Commercial workshops, warehouses, factories and industrial buildings can become extremely hot during the warmer months." },
      { p: "Unlike a typical home, many commercial buildings don't have an enclosed roof cavity. Instead, they consist of large, open work areas with high ceilings and expansive metal roofs that absorb significant amounts of heat throughout the day." },
      { p: "As that heat builds, it naturally rises and accumulates at the highest point of the building. This is where high-capacity solar roof ventilation can make a significant difference." },
      { p: "Rather than simply ventilating a traditional roof cavity, commercial-grade solar ventilation can actively extract hot, stale air from the building's open internal volume, helping improve airflow, reduce heat build-up and create a more comfortable working environment." },

      { h: "Hot Air Naturally Rises" },
      { p: "A large workshop or warehouse can contain thousands of cubic metres of air. During summer, heat can come from the roof itself as well as machinery, vehicles, manufacturing processes, lighting and people. As this heat rises, it can accumulate beneath the highest point of the building." },
      { p: "Without sufficient ventilation, that hot air can remain trapped inside throughout the day. Roller doors can provide natural airflow, but they aren't always open or practical to use for ventilation — security, weather, operational requirements and temperature control can all mean doors need to remain closed." },
      { p: "Active solar ventilation provides a way to continuously extract this accumulated hot air from high level." },

      { h: "You Don't Need a Roof Cavity" },
      { p: "Solar roof ventilation isn't limited to buildings with an enclosed roof space. In many commercial applications, the underside of the metal roof is directly above the occupied workspace. A high-level solar ventilator can therefore extract air directly from the main building volume." },
      { p: "The principle is straightforward: hot air rises → the ventilator extracts it → replacement air enters → the cycle continues. The aim is to continuously move air through the building rather than allowing heat and stale air to accumulate." },

      { h: "Sizing Commercial Ventilation by Air Changes" },
      { p: "For commercial applications, ventilation can be sized according to the volume of the building and the number of complete air changes required per hour. The basic calculation is:" },
      { p: "Length × Width × Height = Building Volume (m³) — that volume is then multiplied by the desired air changes per hour (ACH)." },
      { p: "For general heat removal and improving airflow in an open commercial workspace, 10 complete air changes per hour can be used as a practical design benchmark. For example, a workshop measuring 30 m × 20 m × 6 m = 3,600 m³. At 10 air changes per hour, 3,600 × 10 = 36,000 m³/hour of total extraction capacity." },
      { p: "This is why commercial ventilation needs to be sized according to the actual volume of the building, rather than simply the floor area." },
      { h: "15–20 Air Changes for Fumes and Odours" },
      { p: "Where the objective extends beyond general heat removal and the building contains significant fumes, odours or higher internal heat loads, a higher air-change rate may be appropriate — a target of approximately 15–20 complete air changes per hour, depending on the specific application." },
      { table: {
        caption: "Required airflow for a 3,600 m³ workshop (30 × 20 × 6 m)",
        head: ["Air changes / hour", "Objective", "Required airflow"],
        rows: [
          ["10 ACH", "General heat removal & improved airflow", "36,000 m³/hour"],
          ["15 ACH", "Higher ventilation requirement", "54,000 m³/hour"],
          ["20 ACH", "Fumes, odours & high heat loads", "72,000 m³/hour"],
        ],
        note: "This demonstrates how quickly the required airflow increases when dealing with larger commercial spaces.",
      } },
      { p: "Where hazardous fumes, gases, dust or contaminants are generated, general roof ventilation should not replace purpose-designed local exhaust ventilation. Those applications should be assessed against the relevant workplace health, safety and engineering requirements." },

      { h: "High-Capacity Ventilation with the SAV-60T" },
      { p: "For larger commercial buildings, SolarArk's SAV-60T provides approximately 5,250 m³/hour of airflow. This makes it well suited to larger workshops, warehouses and industrial spaces where considerably more airflow is required than a typical residential ventilator can provide." },
      { p: "Using the 10 ACH benchmark: 5,250 ÷ 10 = 525. As a simplified example, one SAV-60T provides the extraction capacity equivalent to 10 air changes per hour in approximately 525 m³ of building volume. Multiple units can then be used where larger volumes require greater total airflow." },

      { h: "Even More Airflow with the SAV-120T" },
      { p: "For larger commercial and industrial applications, the SAV-120T provides approximately 11,220 m³/hour. Using the same 10 ACH calculation: 11,220 ÷ 10 = 1,122 — one SAV-120T provides the extraction capacity equivalent to 10 complete air changes per hour in approximately 1,122 m³ of building volume." },
      { p: "The SAV-120T is therefore particularly suited to larger:" },
      { ul: ["Warehouses", "Manufacturing facilities", "Industrial workshops", "Machinery sheds", "Distribution facilities", "Agricultural buildings", "Large open-plan commercial spaces"] },
      { p: "For even larger buildings, multiple SAV-120T units can be installed to achieve the required total airflow." },

      { h: "Active Solar Ventilation vs Wind-Driven Turbines" },
      { p: "Many commercial buildings already use, or have considered using, large wind-driven turbine ventilators. Wind-driven turbines can provide useful passive ventilation, but their performance is inherently dependent on wind conditions. When there is little or no wind, there is limited mechanical assistance to draw air from the building." },
      { p: "Active solar ventilation takes a different approach. A SolarArk system uses a powered extraction fan to actively move a defined volume of air, with performance that isn't dependent on the roof ventilator spinning because of wind." },
      { p: "This distinction becomes particularly important during hot summer conditions. The building may be experiencing its greatest heat load on a hot, still day — exactly when a wind-driven turbine has the least natural assistance. A solar-powered system, by comparison, can actively extract air during daylight hours when the sun is heating the building." },

      { h: "High Airflow Without Relying on Wind" },
      { p: "The difference becomes particularly significant with SolarArk's high-capacity commercial systems. The SAV-120T is rated at approximately 11,220 m³/hour, giving it the capacity to actively move a substantial volume of air through a commercial building." },
      { p: "For perspective, SolarArk's published comparison shows the SAV-120T providing up to four times the airflow of some of the largest commonly available wind-driven roof ventilators. This isn't simply about having a larger ventilator — it's about actively moving a known volume of air." },
      { p: "For a commercial building requiring a specific number of air changes per hour, having a defined airflow capacity makes it possible to calculate how many units are required to achieve the desired ventilation rate." },

      { h: "Why Airflow Capacity Matters" },
      { p: "When dealing with a large commercial building, the important question isn't simply \"How many roof ventilators do I need?\" The better question is \"How many cubic metres of air do I need to move every hour?\"" },
      { p: "Once the building volume and required air-change rate are established, the required extraction capacity can be calculated and the appropriate combination of SolarArk systems selected. This provides a much more reliable approach to commercial ventilation than simply installing a few roof vents and hoping they provide enough airflow." },

      { h: "Solar Powered and Designed for Daytime Heat" },
      { p: "One of the key advantages of SolarArk's commercial systems is that they are powered by the sun. The building experiences its greatest solar heat load during the day, while the solar ventilators are simultaneously generating the energy required to extract hot air." },
      { p: "This makes solar ventilation particularly well suited to workshops and warehouses that operate primarily during daylight hours. There is no ongoing electricity cost for normal solar operation, providing a practical way to actively ventilate large spaces without relying entirely on mains-powered extraction." },

      { h: "Don't Forget Replacement Air" },
      { p: "Extraction is only one part of an effective ventilation system. As air is removed from a workshop or warehouse, replacement air needs a pathway to enter. Depending on the building, this may be through:" },
      { ul: ["Roller doors", "Wall louvres", "Windows", "Existing ventilation openings", "Dedicated intake vents"] },
      { p: "The size and location of these openings should be considered when designing the overall ventilation system. You cannot effectively extract large volumes of air without providing a suitable pathway for replacement air." },

      { h: "A Smarter Approach to Commercial Ventilation" },
      { p: "Every commercial building is different. A 500 m² warehouse with a 4-metre ceiling contains a very different volume of air to a 500 m² workshop with an 8-metre ceiling. That's why SolarArk focuses on building volume and required air changes, rather than simply specifying a number of ventilators based on floor area." },
      { p: "As a general guide: 10 ACH for general heat removal and improved airflow; 15–20 ACH for higher ventilation requirements involving fumes, odours or significant internal heat loads. From there, the required airflow can be calculated and the appropriate SolarArk system selected." },

      { h: "Commercial Solar Ventilation from SolarArk" },
      { p: "SolarArk's SAV-60T and SAV-120T provide the high-volume airflow required for larger commercial and industrial applications. With airflow capacities of approximately 5,250 m³/hour and 11,220 m³/hour respectively, they provide a scalable solution for workshops, warehouses, factories and other large open workspaces." },
      { p: "If your commercial building is becoming excessively hot, the first step is to understand how much air the building contains and how quickly that air needs to be replaced. Talk to SolarArk about your building, and we can help determine the airflow capacity required for your application." },
    ],
  },
  {
    slug: "solar-roof-ventilation-vs-whirlybirds",
    title: "Whirlybirds vs solar roof ventilation: which actually keeps your home cooler?",
    excerpt: "Whirlybirds only spin when the wind blows. Here's how solar roof ventilation moves dramatically more air, all day, and why it's the smarter upgrade.",
    category: "Ventilation",
    date: "24 Jun 2026",
    read: "5 min read",
    author: "SolarArk Team",
    iso: "2026-06-24",
    image: IMG.ventRoofInstall,
    body: [
      { p: "If you've been searching for whirlybirds to cool your roof space, it's worth knowing what you're actually buying. A whirlybird — also called a turbine or wind vent — is a passive device. It only spins, and only extracts air, when there is enough wind to turn it. On a still, baking-hot afternoon, exactly when your roof cavity is at its worst, a whirlybird is often barely moving." },
      { h: "How much air does a whirlybird really move?" },
      { p: "A typical whirlybird moves in the order of 100 m³ of air per hour on a windy day — and close to nothing when the air is calm. To ventilate a normal roof space you often need several of them spinning across the roofline, and even then their output rises and falls with the weather rather than with the heat you actually want to remove." },
      { h: "How solar roof ventilation is different" },
      { p: "A SolarArk solar roof ventilator doesn't wait for wind. A solar panel drives a brushless motor that actively pulls hot, stale air out of the roof cavity and draws cooler air in through the eaves — continuously, from sun-up to sun-down. That means the ventilation is strongest at exactly the time your roof is hottest and the sun is highest." },
      { table: {
        caption: "Whirlybird vs SolarArk solar ventilation",
        head: ["", "Whirlybird", "SolarArk"],
        rows: [
          ["Power source", "Wind only", "Solar powered"],
          ["Airflow", "≈ 100 m³/hour on a windy day", "Up to 11,220 m³/hour, continuously"],
          ["Extraction", "Passive, weather-dependent", "Active, motor-driven all day"],
          ["Units for a large roof", "Up to 52 spinning vents", "One SAV-60T"],
          ["Noise", "Can squeak and rattle", "Whisper-quiet"],
          ["Vermin proof", "No — open throat", "Yes — sealed design"],
        ],
        note: "One SolarArk SAV-60T moves the same air as up to 52 traditional whirlybirds.",
      } },
      { h: "The same $0 running cost — but real performance" },
      { p: "People love whirlybirds because they cost nothing to run. The good news is a SolarArk ventilator is also totally solar powered, so it also costs $0 to run for the life of the product — no wiring to the switchboard, no electricity bills, no switches. The difference is that you get thousands of cubic metres of guaranteed airflow every sunny day instead of a vent that only works when the wind decides to cooperate." },
      { h: "Upgrading from whirlybirds" },
      { p: "Replacing whirlybirds is straightforward. In most homes a single SolarArk unit replaces several spinning vents while delivering far more airflow, no noise, and a fully vermin-proof design. Every SolarArk ventilator is built for straightforward DIY installation, or we can connect you with a trusted installer from our national network." },
      { p: "Not sure how many whirlybirds a SolarArk unit would replace on your roof? Try our interactive airflow calculator or request a quote and our team will size the right model for you." },
    ],
  },
  {
    slug: "10x-air-changes-per-hour-roof-ventilation-guide",
    title: "The 10x Air Changes Per Hour Guide: How Much Roof Ventilation Do You Need?",
    excerpt: "A simple benchmark for sizing roof ventilation — how to calculate your roof cavity's airflow requirement and match it to the right SolarArk model.",
    category: "Guides",
    date: "20 Jun 2026",
    read: "4 min read",
    author: "SolarArk Team",
    iso: "2026-06-20",
    image: `${ASSETS}/3zt3mzar_Gemini_Generated_Image_ct1ewpct1ewpct1e.webp`,
    body: [
      { p: "When it comes to roof ventilation, one of the most common questions we get is: \u201cHow much ventilation does my roof space actually need?\u201d A simple starting point is the 10x air changes per hour (ACH) guideline." },
      { h: "What does 10x air changes per hour mean?" },
      { p: "10 air changes per hour means replacing the total volume of air within your roof cavity 10 times every hour. This helps remove the hot, stagnant air that builds up in the roof space during warmer weather and replace it with cooler outside air." },
      { p: "For many residential roof spaces, targeting 10 air changes per hour provides a useful benchmark for heat displacement and general roof-space ventilation." },
      { h: "How do you calculate it?" },
      { p: "The basic calculation is: Required Airflow = Roof Area × Cavity Height × 10. For the cavity height, use half of your peak roof cavity height — halving it accounts for the sloping shape of the roof. For example, a roof that peaks 3 m above the ceiling uses 1.5 m in the calculation." },
      { table: {
        caption: "Worked example — 200 m² roof",
        head: ["Step", "Calculation", "Result"],
        rows: [
          ["Roof cavity volume", "200 m² × 1.5 m (½ of the 3 m peak cavity height)", "300 m³"],
          ["10 air changes per hour", "300 m³ × 10", "3,000 m³/hour"],
        ],
        note: "For this roof you would require approximately 3,000 m³/hour of ventilation airflow.",
      } },
      { h: "Choosing the right solar roof ventilator" },
      { p: "Once you know the required airflow, you can compare it against the airflow rating of the ventilation unit. For example, SolarArk's SAV-20 operates at approximately 2,718 m³/hour, while the SAV-40T operates at approximately 3,660 m³/hour." },
      { p: "For a roof requiring around 3,000 m³/hour, the SAV-40T would therefore provide sufficient airflow to achieve the 10x target." },
      { p: "The \u201cT\u201d models also feature an adjustable tilt solar panel, allowing the panel to be positioned towards the north on roofs where the ventilator itself cannot be installed on a north-facing roof pitch." },
      { h: "Why aim for 10 air changes per hour?" },
      { p: "A well-designed ventilation system can help: remove accumulated heat from the roof cavity, reduce roof-space temperatures, reduce the amount of heat transferred into the living areas below, help manage moisture and condensation, and improve overall roof-space airflow." },
      { p: "The 10x target is a useful starting point, but the ideal ventilation rate can vary depending on the application. For areas where you're dealing with significant heat, odours or fumes, a higher air-change target may be appropriate." },
      { h: "Need help calculating your roof ventilation?" },
      { p: "Every roof is different. Roof area, cavity height, roof design, insulation, orientation and the intended use of the space can all influence the ventilation requirements." },
      { p: "If you're unsure which SolarArk ventilator is right for your property, SolarArk can help calculate the required airflow and recommend a suitable model for your roof space. Try our interactive airflow calculator or request a quote and our team will size it for you." },
    ],
  },
  {
    slug: "understanding-ncc-2022-clause-10-8-3",
    title: "Understanding NCC 2022 Clause 10.8.3",
    excerpt: "What the new roof-space ventilation and condensation management rules mean for builders — and how solar ventilators satisfy them.",
    category: "Compliance",
    date: "12 May 2025",
    read: "6 min read",
    author: "Daniel Hughes",
    iso: "2025-05-12",
    image: "/ncc-10-8-3-table.svg",
    body: [
      { p: "Introduced in NCC 2022, Clause 10.8.3 forms a critical part of the new Condensation Management provisions in Volume Two. Its aim is simple: improve the durability, energy efficiency and indoor air quality of Australian homes by ensuring roof spaces are properly ventilated." },
      { p: "Modern construction techniques create more airtight, thermally efficient homes. That's great for comfort and running costs — but it also increases the risk of trapped moisture in the building envelope. In the roof space, heat, humidity and poor air movement can quickly lead to condensation, mould and premature material failure." },
      { h: "What the clause actually requires" },
      { p: "In Climate Zones 6, 7 and 8, a roof space must be ventilated to outdoor air through evenly distributed openings in accordance with Table 10.8.3. The required free open area is set per metre of the roof's longest horizontal dimension, and varies by roof pitch:" },
      { table: {
        caption: "Table 10.8.3 — Roof space ventilation requirements",
        head: ["Roof pitch", "Ventilation openings"],
        rows: [
          ["< 10°", "25,000 mm²/m provided at each of two opposing ends"],
          ["≥ 10° and < 15°", "25,000 mm²/m at the eaves and 5,000 mm²/m at high level"],
          ["≥ 15° and < 75°", "7,000 mm²/m at the eaves and 5,000 mm²/m at high level, plus an additional 18,000 mm²/m at the eaves if the roof has a cathedral ceiling"],
        ],
        note: "Openings are a minimum free open area per metre of the roof's longest horizontal dimension. High-level openings are at the ridge or no more than 900 mm below it. Source: NCC 2022 / ABCB Housing Provisions Standard.",
      } },
      { h: "Where solar ventilation comes in" },
      { p: "A passive vent only moves air when conditions allow. A SolarArk solar ventilator actively drives continuous convective air exchange whenever the sun is out — delivering sustained ventilation rates that meet and exceed the Deemed-to-Satisfy provisions, particularly in Climate Zones 6, 7 and 8." },
      { p: "Because free open area is measured at a completely unobstructed base opening, a single SAV-20 delivers 196,349 mm² of effective airflow — far beyond a traditional whirlybird. For the full method and worked examples, see our NCC 10.8.3 page." },
    ],
  },
  {
    slug: "how-solar-ventilation-cools-your-home",
    title: "How solar roof ventilation makes your home up to 30°C cooler",
    excerpt: "Your roof cavity can hit 60°C+ in summer. Here's how extracting that trapped heat transforms comfort and cooling costs.",
    category: "Ventilation",
    date: "3 Feb 2025",
    read: "5 min read",
    author: "SolarArk Engineering",
    iso: "2025-02-03",
    image: IMG.ventRoofInstall,
    body: [
      { p: "On a hot Australian afternoon, the air trapped in your roof cavity can soar well past 60°C. That superheated air radiates down into your living spaces long after the sun has set, forcing your air conditioner to work harder and longer." },
      { h: "Extract the heat, at zero cost" },
      { p: "SolarArk ventilators continuously draw that hot air out of the roof space and replace it with cooler air drawn through the eaves. The result: roof-cavity temperatures reduced by up to 30°C and living-room temperatures by up to 6°C — dramatically improving the efficiency of your cooling system." },
      { p: "Because every unit is totally solar powered, this happens at $0 running cost for the life of the product. No wiring to the switchboard, no bills, no switches to remember." },
      { h: "Not just summer" },
      { p: "In cooler months, continuous ventilation reduces condensation and the build-up of mould spores in the roof space — protecting your home's structure and your family's air quality. An adjustable digital thermostat lets you retain roof warmth when you want it." },
    ],
  },
  {
    slug: "choosing-the-right-solarark-ventilator",
    title: "Choosing the right SolarArk ventilator for your roof",
    excerpt: "North-facing or not, tin or tile, 100 m² or 300 m² — a quick guide to matching the SAV range to your roof.",
    category: "Guides",
    date: "18 Nov 2024",
    read: "4 min read",
    author: "SolarArk Team",
    iso: "2024-11-18",
    image: IMG.ventNewInstall,
    body: [
      { p: "With nine models in the SAV range, choosing the right ventilator comes down to three things: your roof size, your roof pitch, and which way it faces." },
      { h: "Size and pitch" },
      { p: "As a rule of thumb, a 100 m² roof is well served by a single SAV-10B, while larger or steeper roofs step up to the SAV-20, SAV-30 or multiple units. Use our interactive airflow calculator to get an instant recommendation for your roof." },
      { h: "Which way does your roof face?" },
      { p: "Standard models are designed for north-facing pitches where they capture the most sun. If your best roof plane faces east, south or west, choose a tilt-panel 'T' model (SAV-10T, SAV-20T, SAV-40T, SAV-60T) — its directional panel angles toward the sun for full performance in any orientation." },
      { h: "Commercial and industrial" },
      { p: "For warehouses and large cavities, one SAV-60T moves the same air as up to 52 traditional whirlybirds, and the flagship SAV-120T delivers a massive 11,220 m³/hr. When in doubt, our team will size it for you." },
    ],
  },
  {
    slug: "solar-hot-water-and-stc-rebates-explained",
    title: "Solar hot water & STC rebates explained",
    excerpt: "Water heating is the second-largest energy cost in most homes. Here's how evacuated tube systems and rebates change the maths.",
    category: "Solar Hot Water",
    date: "24 Sep 2024",
    read: "5 min read",
    author: "SolarArk Team",
    iso: "2024-09-24",
    image: IMG.hwEvacuated,
    body: [
      { p: "Heating water is the second-largest energy cost in the average Australian home. A high-efficiency evacuated tube solar hot water system can supply up to 90% of that demand straight from the sun — even on cold, overcast days." },
      { h: "Why evacuated tubes" },
      { p: "Each vacuum-sealed tube acts like a thermos, capturing solar energy while minimising heat loss. That makes them highly effective in low ambient temperatures and diffuse light, where flat-plate collectors struggle. A boosted backup ensures you never run out of hot water." },
      { h: "The rebate maths" },
      { p: "Most SolarArk solar hot water systems qualify for Small-scale Technology Certificates (STCs) under the federal Renewable Energy Target, plus various state-based incentives. These can substantially reduce the up-front cost." },
      { p: "The exact number of STCs depends on your system and postcode zone. Our team calculates your precise rebate — and models your return on investment — before you commit." },
    ],
  },
];

